import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@Env';
import { AuthService } from '@Services/auth.service';
import { MatButton, MatAnchor } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { FsOrgCustomization } from '../../../../environments/fs-org-environment';
import version from '../../../../assets/data/version.json';

@Component({
    selector: 'fs-welcome-page',
    templateUrl: './welcome-page.component.html',
    styleUrls: ['./welcome-page.component.scss'],
    imports: [MatButton, MatAnchor, TranslatePipe]
})
export class WelcomePageComponent implements OnInit {
  readonly auth = inject(AuthService);

  readonly route = inject(ActivatedRoute);

  error: string;

  readonly CUSTOMIZATION: FsOrgCustomization = environment.customization;

  readonly CURRENT_YEAR = new Date().getFullYear();

  readonly VERSION = version.version;

  ngOnInit() {
    if (this.route.snapshot.queryParams.error) {
      this.error = this.route.snapshot.queryParams.error;
    }
  }

  login(): void {
    this.auth.keycloak.login({ idpHint: environment.authIdpHint });
  }

  register(): void {
    this.auth.keycloak.register();
  }
}
